const SupportLink: React.FC = () => (
  <a href="https://wa.me/+5511987826794" target="_blank" rel="noopener">
    WhatsApp: (11) 98782-6794
  </a>
);

export const SuccessPage: React.FC = () => (
  <div className="page">
    <div className="page__inner">
      <div className="logo-text">Vammo</div>

      <div className="success-icon">✓</div>

      <h1 className="title">
        <span className="accent">Tudo certo.</span>
        <br />
        Sua migração foi concluída.
      </h1>
      <p className="subtitle">
        Seu novo plano já está ativo. A semana em curso já passa a valer no
        novo formato e o novo valor aparecerá na sua próxima cobrança. Você
        não precisa fazer mais nada.
      </p>

      <div className="success-box">
        <h3>O que acontece agora</h3>
        <ul>
          <li>
            Seu plano já foi atualizado para o novo formato — passa a valer
            imediatamente.
          </li>
          <li>
            Sua próxima cobrança já virá com o novo valor, refletindo a semana
            em curso.
          </li>
        </ul>
      </div>

      <p className="form__help mt-5">
        Dúvidas? Fale com o suporte no <SupportLink />.
      </p>
    </div>
  </div>
);

type IneligibleVariant = "comfort_mensal" | "generic";

export const IneligiblePage: React.FC<{ variant?: IneligibleVariant }> = ({
  variant = "generic",
}) => (
  <div className="page">
    <div className="page__inner">
      <div className="logo-text">Vammo</div>

      <span className="eyebrow">Atendimento necessário</span>
      <h1 className="title">
        Sua migração precisa de{" "}
        <span className="accent">atendimento dedicado</span>.
      </h1>

      <div className="info-box">
        {variant === "comfort_mensal" ? (
          <p>
            Sua conta está no plano <strong>Comfort Mensal</strong>, que não
            está disponível para migração automática por este canal.
          </p>
        ) : (
          <p>
            Não foi possível migrar seu plano por este canal. Pode ser que sua
            assinatura ainda não seja elegível para a nova cobrança por km, ou
            que ela precise de uma revisão manual.
          </p>
        )}
        <p>
          Para alterar a periodicidade ou o preço do seu plano, fale direto com
          nosso atendimento:
        </p>
        <p>
          <SupportLink />
        </p>
      </div>
    </div>
  </div>
);

export const ExpiredPage: React.FC = () => (
  <div className="page">
    <div className="page__inner">
      <div className="logo-text">Vammo</div>

      <span className="eyebrow">Campanha encerrada</span>
      <h1 className="title">
        Esta migração online <span className="accent">foi encerrada</span>.
      </h1>

      <div className="info-box">
        <p>A mudança de preço não está mais disponível por aqui.</p>
        <p>Para modificar sua assinatura, fale com nosso atendimento:</p>
        <p>
          <SupportLink />
        </p>
      </div>
    </div>
  </div>
);

export const NotRegisteredPage: React.FC<{ onRetry: () => void }> = ({
  onRetry,
}) => (
  <div className="page">
    <div className="page__inner">
      <div className="logo-text">Vammo</div>

      <span className="eyebrow">Atendimento necessário</span>
      <h1 className="title">
        Não encontramos sua <span className="accent">conta</span>.
      </h1>

      <div className="info-box">
        <p>
          O número informado não está vinculado a uma conta Vammo ativa
          elegível para migração online.
        </p>
        <p>Se você acha que isso é um engano, fale com nosso suporte:</p>
        <p>
          <SupportLink />
        </p>
      </div>

      <div className="comparison-cta">
        <button type="button" className="btn btn--ghost" onClick={onRetry}>
          Tentar com outro número
        </button>
      </div>
    </div>
  </div>
);
